import { useI18n } from '@/hooks/useI18n';
import { formatPlanAmount } from '@/lib/builder/utils/payment-format';
import { IUnconfirmedKpis } from '@/lib/payments/models/payments-dashboard.model';

interface UnconfirmedSummaryProps {
    kpis: IUnconfirmedKpis | undefined;
}

/**
 * Testata della scheda "Da confermare": cosa sono queste righe e quanto valgono.
 *
 * Le righe sono quelle di DueInstallmentsCard -- la prima rata aperta di ogni proposta,
 * con le stesse azioni -- e questo e' l'unico pezzo proprio della vista. I totali vengono
 * dalla RPC e contano l'insieme intero, non la pagina.
 */
export const UnconfirmedSummary = ({ kpis }: UnconfirmedSummaryProps) => {
    const { t } = useI18n();

    return (
        <>
            <p className="text-sm text-gray-500">{t('payments.unconfirmed.hint')}</p>
            {kpis && (
                <div className="grid grid-cols-3 gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
                    <div>
                        <div className="text-xs text-gray-500">{t('payments.unconfirmed.count')}</div>
                        <div className="font-semibold text-gray-900 tabular-nums">{kpis.count}</div>
                    </div>
                    <div>
                        <div className="text-xs text-gray-500">
                            {t('payments.unconfirmed.firstInstallmentsTotal')}
                        </div>
                        <div className="font-semibold text-gray-900 tabular-nums">
                            {formatPlanAmount(kpis.first_installments_amount)}
                        </div>
                    </div>
                    <div>
                        <div className="text-xs text-gray-500">{t('payments.unconfirmed.tripsTotal')}</div>
                        <div className="font-semibold text-gray-900 tabular-nums">
                            {formatPlanAmount(kpis.total_amount)}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
